import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './navbar.css'

const NAV_LINKS = [
  { to: '/',                     label: 'Home' },
  { to: '/business-funding-page', label: 'Business Funding' },
  { to: '/vehicle-rent-page',     label: 'Vehicle Rent‑to‑Own' },
]

const Navbar = () => {
  const location = useLocation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <nav className="navbar-container" aria-label="Site navigation">
        <div className="navbar-inner">
          {NAV_LINKS.map(({ to, label }) => (
            <Link key={to} to={to} className="navbar-link" onClick={() => setOpen(false)}>
              <div className={`navbar-item${location.pathname === to ? ' navbar-item--active' : ''}`}>
                {label}
              </div>
            </Link>
          ))}
        </div>

        <button
          className={`navbar-burger${open ? ' navbar-burger--open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen(o => !o)}
        >
          <span /><span /><span />
        </button>
      </nav>

      <div className={`navbar-mobile-drawer${open ? ' open' : ''}`} aria-hidden={!open}>
        {NAV_LINKS.map(({ to, label }) => (
          <Link key={to} to={to} className="navbar-link" onClick={() => setOpen(false)}>
            <div className={`navbar-item${location.pathname === to ? ' navbar-item--active' : ''}`}>
              {label}
            </div>
          </Link>
        ))}
      </div>
    </>
  )
}

export default Navbar
